import { GetExclusiveId, NumberFormat } from "../../utils/tools";
import EngineeringMapping from "../_service/singletonTools/engineeringMapping";
import { Equation } from "./EquationModel";

export default class Properties {
    constructor(props = {}) {
        this.id = `prop-${GetExclusiveId()}`;
        this.height = props ? props.height : 0;
        this.x = (x) => x + 5;
        this.y = (y) => y + this.height - 3;
        this.observation = props.observation ? props.observation : "";

        // Propriedades do Engenharia
        this.caption = props.caption ? props.caption : "";
        this.unit = props.unit ? props.unit : "";
        this.key = props.key ? props.key : "";
        this.value = NumberFormat(props.value);
        this.strValue = props.strValue ? props.strValue : "";
        this.index = props.index ? props.index : "";
        this.propIndex = props.propIndex;
        this.type = props.type ? props.type : "";
        this.subType = props.subType ? props.subType : "";
        this.component = props.component ? props.component : "";
        this.equipName = props.equipName ? props.equipName : "";
        this.propName = props.propName ? props.propName : "";
        this.isInput = props.isInput ? props.isInput : false;
        this.refCalc = props.refCalc ? new Equation({...props.refCalc}) : new Equation();
        this.mapping = props.mapping ? props.mapping : EngineeringMapping.setMapping(this)

        this.text = () =>{
            return  this.caption ?
                    `${this.caption}: ${this.value} ${this.unit || ""}` :
                    `${this.value} ${this.unit || ""}`;
        }

        this.clone = () => {
            let cloned = new Properties();
            cloned.id = `prop-${GetExclusiveId()}`;
            cloned.height = this.height;
            cloned.caption = this.caption;
            cloned.unit = this.unit;
            cloned.key = this.key;
            cloned.value = NumberFormat(this.value);
            cloned.strValue = this.strValue;
            cloned.index = this.index;
            cloned.propIndex = this.propIndex;
            cloned.type = this.type;
            cloned.subType = this.subType;
            cloned.component = props.component ? props.component : "";
            cloned.equipName = this.equipName;
            cloned.propName = this.propName;
            cloned.observation = this.observation;
            cloned.isInput = this.isInput;
            cloned.component = this.component;
            cloned.mapping = this.mapping ? this.mapping : EngineeringMapping.setMapping(this);
            cloned.refCalc = this.refCalc ? this.refCalc.clone() : new Equation();

            return cloned;
        };

    this.isEquals = (prop = new Properties()) => {
        let result = this.key == prop.key
        result = this.index == prop.index && result
        result = this.propName == prop.propName && result
        result = this.equipName == prop.equipName && result
        result = this.component == prop.component && result
        result = this.subType == prop.subType && result
        result = this.refCalc.equation == prop.refCalc.equation && result
        result = this.mapping == prop.mapping && result
        return result;
    };

    this.setResultCalc = function(result = {}){
        this.value = result.value == -9999 ? this.value : NumberFormat(result.value)
        this.caption = this.refCalc.caption ? this.refCalc.caption : this.caption
        this.unit = this.refCalc.unit ?  (String(this.refCalc.unit).toUpperCase() == 'NA' ? '' : this.refCalc.unit) : this.unit
    }
  }
}